import Model from '@/models/ExtendModel'

export default class PchPurchaseOrderState extends Model {
    resource() {
        return 'pch_purchase_order_state'
    }
}